export const lineManagerQueryKeys = {
  get_line_manager: (queryParams = {}) =>
    ['get_line_manager', queryParams] as const,
  put_line_manager: (queryParams = {}) =>
    ['put_line_manager', queryParams] as const
}
